/**
 * Wrapper for app runner, which function is to load polyfills first
 */

import '../clientPolyfills'

import { getServerContext } from '@app/utils/getServerContext'
import { loadBrowserIntlPolyfill } from '@app/utils/IntlUtils'
import { loadUnorm } from '@app/utils/unormPolyfill'

import { localeSelector } from '@app/store/slices/locale'

async function app() {
  if ((window as any).ERROR) return

  const ctx = getServerContext()

  await Promise.all([loadBrowserIntlPolyfill(localeSelector(ctx.storeState)), loadUnorm()])

  // `require`, not `import()`: the app must not evaluate before the polyfills above, and a
  // dynamic import puts it in a chunk of its own — a second round trip for 250kb the page
  // always needs. A sync require is inlined here and evaluated at this line.
  const { ClientRunner } = require('../run.client') as typeof import('../run.client')
  const runner = new ClientRunner()
  await runner.load(ctx)
  await runner.run()
}

void app()
